import "./Button.css";

function Button(props) {
  return (
    <input className="Button" type="button" {...props}/>
  );
}
export default Button;
